import React,{useEffect} from 'react'
import BaseProductInfosColumnModel from './base-product-infos-column-model'
import CommonTablePage, { CommonTablePagePropsInterface } from '../../../components/common/common-table/common-table-page'
import { urlKey } from '../../../services/api/api-urls'
import { useDocumentTitle } from '../../../services/title/useDocumentTitle'

const BaseProductInfosPage: any = (props: any) => {

  const commonTablePageProps: CommonTablePagePropsInterface = {
    urlInfoKey: urlKey.BaseProduct,
    getAllUrl: 'ProductForShowing/GetAllShowingProducts',
    title: props.title || 'Product List',
    column: BaseProductInfosColumnModel(),
    isNotEditable: true,
    isNotDeletable: true,
    isNotAddable: true
  }
  useDocumentTitle();

  // useEffect(() => {   
  //   document.title="Sales Products List"
  // }, [])
  return (
    <>
      <CommonTablePage
        {...commonTablePageProps}
      />
    </>
  )
}

export default BaseProductInfosPage
